import { gql } from '@apollo/client';

export const DELETE_COMMENT_MUTATION = gql`
  mutation RemoveComment($id: Int!) {
    removeComment(id: $id) {
      id
    }
  }
`;